export default {
  title: "",
  subtitle: "Status for Pay-In transactions",
  path: "transaction_status_pay_in",
  paragraph: '',
  request: {},
  domainsProperties: [
    {
      name: "pending",
      values: "No payment was made by the customer."
    },
    {
      name: "identified (from local currency to foreign currency)",
      values: "The funds from the transaction were received in the local currency, but were not yet converted to the foreign currency."
    },
    {
      name: "identified (from local currency to local currency)",
      values: "The funds from the transaction were received in the local currency and are now available on your internal account. This is a final status for this scenario"
    },
    {
      name: "exchanged",
      values: "The money was converted to the foreign currency. If the destination account is an internal, this will be the final status"
    },
    {
      name: "wired",
      values: "It is the final status for pay-in done to your external international bank account, means the payment was successfully made"
    },
    {
      name: "canceled",
      values: "When for any reason the transaction cannot be concluded or need to be reversed, it is canceled."
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/TransactionStatusPayIn.js